import React, { useState, useEffect } from "react";
//import "./styles.css";
import { Form } from "react-bootstrap";
import "./shareable-images.css";
import { Pdf } from "../../../../assets/images";
import axios from "../../../../axios/axios";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import { adminConfig } from "../../../../utils/adminConfig";

const ShareableImages = () => {
  const [file, setFile] = useState("");
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [cals, setCals] = useState([]);

  const addCalendar = async (e) => {
    e.preventDefault();

    setLoading(true);
    let data = new FormData();

    if (file) {
      data.append("pdf", file);
      data.append("title", title);
      // data.append("isTripValet", isTripValet);
      // data.append("isTripValetIncentive", isTripValetIncentive);

      await axios
        .post(`/add-image`, data, adminConfig())
        .then((res) => {
          if (res.data.status === true) {
            message.success("added Image");
          } else {
            message.error("failed adding Image");
          }
        })
        .catch((err) => {
          console.log(err);
        });
      setLoading(false);
    } else {
      message.error("file not found");
      setLoading(false);
    }
  };
  const getCalendars = () => {
    setLoading(true);

    axios
      .get(`/get-image`, adminConfig())
      .then((res) => {
        if (res.data.status === true) {
          // message.success("fetched calendar success");
          setCals(res.data.data);
          // setPagination(res.data.pagination);
          setLoading(false);
        } else {
          message.error("Data Not Found");
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getCalendars();
  }, []);
  return (
    // <div>
    //     <HeaderPart />
    //     <div className='main_cont'>
    //         <LeftpanelAdmin />
    <LoadingOverlay active={loading} spinner text="loading...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="text_field_partts">
              <div className="user_added resources_p">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Enter Title</Form.Label>
                  <Form.Control
                    type="text"
                    value={title}
                    onChange={(e) => {
                      setTitle(e.target.value);
                    }}
                    placeholder="Enter title"
                    className="text_link"
                  />
                </Form.Group>
                <div className="upload_pdf">
                  <h3>Upload Pdf</h3>
                  <div className="upload_btn_wrapper">
                    <button className="btn_bulk">
                      <span className="cert_bulkks">
                        <img src={Pdf} alt="" />
                      </span>
                      {file ? (
                        file.name
                      ) : (
                        <>
                          Upload Image
                          <input
                            type="file"
                            name="myfile"
                            onChange={(e) => {
                              // console.log(e.target.files[0]);
                              setFile(e.target.files[0]);
                            }}
                          />
                        </>
                      )}
                    </button>
                    {/* <inpu/>t type="file" name="myfile"  /> */}
                  </div>
                </div>

                <div className="sub_but">
                  <button
                    type="button"
                    onClick={addCalendar}
                    className="add_but submit_buttt mt-0"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
            <div className="image_gallery">
              <h2>Image Gallery</h2>
              <div className="gallery_inner">
                {cals.length > 0 &&
                  cals.map((cal) => {
                    return (
                      <div className="gallery_inner_inner">
                        <div className="gallery_box">
                          <a
                            href={cal.imageUrl}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src={cal.imageUrl}
                              // onClick={deleteCal(cal._id)}
                              alt=""
                            />
                          </a>
                          {/* <a
                            className="cross_but"
                            href="#/"
                            // onClick={() => {
                            //   setCalId(cal._id);
                            //   handleShow();
                            // }}
                          >
                            X
                          </a> */}
                          <div className="domain_name">
                            <p>
                              <span>{cal.title}</span>
                              {/* <span>{cal.year}</span> */}
                              {/* {cal.isTripValet && <p>Tripvalet</p>}
                              {cal.isTripValetIncentive && (
                                <p>TripValetIncentive</p>
                              )} */}
                            </p>
                          </div>
                        </div>

                        {/* <span>{cal.date}</span> */}
                      </div>
                    );
                  })}

                {/* <div className="gallery_inner_inner">
                  <div className="gallery_box">
                    <img src={Trip} />
                  </div>
                </div>

                <div className="gallery_inner_inner">
                  <div className="gallery_box">
                    <img src={Trip} />
                  </div>
                </div> */}

                {/* <div className="gallery_inner_inner">
                  <div className="gallery_box">
                    <img src={Trip} />
                  </div>
                </div>

                <div className="gallery_inner_inner">
                  <div className="gallery_box">
                    <img src={Trip} />
                  </div>
                </div>

                <div className="gallery_inner_inner">
                  <div className="gallery_box">
                    <img src={Trip} />
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
};

export default ShareableImages;
